import { Box, Flex, Spinner, Switch, Text } from "@chakra-ui/react";
import React from "react";
import { ConsentType } from "@lubbezposrednio-frontend/core";
import { ConsentsViewModel } from "../ConsentsViewModel";
import { observer } from "mobx-react-lite";
import { useToast } from "@chakra-ui/react";

interface ConsentProps extends ConsentType {
  model: ConsentsViewModel;
}

export const Consent: React.FC<ConsentProps> = observer(({ title, name, content, isChecked, model }) => {
  const toast = useToast();

  return (
    <Flex
      w="100%"
      borderRadius="18px"
      bg="rgba(24,12,48,0.028)"
      p={{ base: "18px", md: "20px" }}
      align="flex-start"
      justify="space-between"
      gap="20px"
    >
      <Box flex="1">
        <Text fontWeight="800" color="primary" fontSize="16px" mb="5px">
          {title}
        </Text>
        <Text fontSize="14px" color="gray.600" lineHeight="1.55">
          {content}
        </Text>
      </Box>

      {model.isLoading ? (
        <Spinner size="sm" color="primary" flexShrink={0} mt="2px" />
      ) : (
        <Switch
          isChecked={isChecked}
          onChange={e => model.changeConsents(name, e.target.checked, toast)}
          colorScheme="purple"
          size="lg"
          flexShrink={0}
          mt="2px"
        />
      )}
    </Flex>
  );
});
